export type Device = Nullable<{
  type: PropsTypesOf<typeof DeviceTypeEnum>['code']
  manufacturer: string
  model: string
  serialNumber: string
  salePrice: number
  saleDate: Date
  description: string
  warrantyTime: number
}>

function load(model?: Partial<Device> | null): Device {
  return {
    type: model?.type ?? null,
    manufacturer: model?.manufacturer ?? null,
    model: model?.model ?? null,
    serialNumber: model?.serialNumber ?? null,
    salePrice: model?.salePrice ?? null,
    saleDate: model?.saleDate ?? null,
    description: model?.description ?? null,
    warrantyTime: model?.warrantyTime ?? null,
  }
}

const DeviceTypeEnum = {
  CpuConsole: { label: 'Consola de juego o CPU', code: 'CpuConsole' },
  Controls: { label: 'Controles', code: 'Controls' },
  GameChair: { label: 'Silla Gamer', code: 'GameChair' },
  Headset: { label: 'Headset Micrófono/Audífono', code: 'Headset' },
  Camera: { label: 'Cámara Web', code: 'Camera' },
  Screen: { label: 'Pantalla', code: 'Screen' },
  Difuser: { label: 'Difusor', code: 'Difuser' },
  Speaker: { label: 'Bocinas', code: 'Speaker' },
  Keyboard: { label: 'Teclado', code: 'Keyboard' },
  Mouse: { label: 'Mouse', code: 'Mouse' },
  VRHeadset: { label: 'Lentes VR', code: 'VRHeadset' },
  PC: { label: 'Ordenadores de mesa, portátiles y ultrabook', code: 'PC' },
  MobilePhone: { label: 'Teléfonos móviles', code: 'MobilePhone' },
  Tablet: { label: 'Tablets', code: 'Tablet' },
} as const

function getDeviceTypeList() {
  return Object.values(DeviceTypeEnum)
}

const map = {
  toAsegurableViewModel(model: Device): SiteApiSchema<'AsegurableViewModel'> {
    return {
      fechaCompra: model.saleDate?.toJSON(),
      marca: model.manufacturer,
      modelo: model.model,
      serie: model.serialNumber,
      mesesGarantiaExtendida: model.warrantyTime,
      montoAsegurado: model.salePrice,
      subModelo: model.type ? DeviceTypeEnum[model.type].label : undefined,
    }
  },
}

export const Device = {
  load,
  getDeviceTypeList,
  map,
}
